import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import HeadlineModal from "./HeadlineModal";
import { useAuth } from "../../contexts/AuthContext";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API ||
  (typeof window !== "undefined" &&
  window.location.hostname.includes("onrender.com")
    ? "https://cvanto-api.onrender.com"
    : "http://localhost:5000");

const API = API_BASE;

const HeadlinePage = () => {
  const { headlineId } = useParams();
  const navigate = useNavigate();
  const { userId } = useAuth() || {};

  const [headline, setHeadline] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchHeadline() {
      if (!headlineId) {
        setNotFound(true);
        setLoading(false);
        return;
      }

      try {
        const { data } = await axios.get(`${API}/api/headlines/${headlineId}`, {
          timeout: 10000,
        });

        if (cancelled) return;

        if (!data || !data.id) {
          setNotFound(true);
        } else {
          setHeadline(data);
        }
      } catch (e) {
        if (!cancelled) {
          setNotFound(true);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchHeadline();
    return () => {
      cancelled = true;
    };
  }, [headlineId]);

  const handleClose = () => {
    // При закритті — назад, а якщо історії нема, то в /feed
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/feed", { replace: true });
    }
  };

  const handleGoProfile = (authorId) => {
    if (!authorId) return;
    navigate(`/profile/${authorId}`);
  };

  if (loading) {
    return null; // Модалка сама перекриє фон, можна не показувати спінер
  }

  if (notFound || !headline) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", sans-serif',
        }}
      >
        <div>
          <div style={{ marginBottom: 12 }}>Headline не знайдено.</div>
          <button
            onClick={() => navigate("/feed", { replace: true })}
            style={{
              padding: "10px 18px",
              borderRadius: 999,
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
              background: "#111827",
              color: "#fff",
            }}
          >
            На головну
          </button>
        </div>
      </div>
    );
  }

  const isAuthor = userId && headline.userId && userId === headline.userId;

  return (
    <HeadlineModal
      headline={headline}
      carouselItems={[headline]}
      initialIndex={0}
      isAuthor={!!isAuthor}
      onClose={handleClose}
      onRespond={null}
      onDelete={null}
      onGoProfile={handleGoProfile}
    />
  );
};

export default HeadlinePage;
